

export const familyMembers = [
  {
    firstName: "Akash",
    lastName: "Sharma",
    relationship: "Self",
    gender: "Male",
    age: 35,
    id: "AA-BB-XXX",
    location: "Delhi",
    style: {
      background: "rgba(255, 248, 204, 1)",
      border: "3px solid rgba(251, 191, 36, 1)",
    },
    // icon: Self,
  },
  {
    firstName: "Nidhi",
    lastName: "Sharma",
    relationship: "Wife",
    gender: "Female",
    age: 28,
    id: "AA-BB-XX1",
    location: "Delhi",
    style: {
      background: "rgba(254, 226, 226, 1)",
      border: "3px solid rgba(248, 113, 113, 1)",
    },
    // icon: spouse,
  },
  {
    firstName: "Naisha ",
    lastName: "Sharma",
    relationship: "Daughter",
    gender: "Female",
    age: 10,
    id: "AA-BB-XX2",
    location: "Delhi",
    style: {
      background: "rgba(236, 253, 245, 1)",
      border: "3px solid rgba(16, 185, 129, 1)",
    },
    // icon: Son,
  },
  {
    firstName: "Romit",
    lastName: "Sharma",
    relationship: "Father",
    gender: "Male",
    age: 68,
    id: "AA-BB-XX3",
    location: "Delhi",
    style: {
      background: "rgba(232, 237, 251, 1)",
      border: "3px solid rgba(29, 78, 216, 1)",
    },
    // icon: Father,
  },
  {
    firstName: "Prita",
    lastName: "Sharma",
    relationship: "Mother",
    gender: "Female",
    age: 62,
    id: "AA-BB-XX4",
    location: "Delhi",
    style: {
      background: "rgba(241, 245, 249, 1)",
      border: "3px solid rgba(148, 163, 184, 1)",
    },
    // icon: Mother,
  },
];

export const symptomCheckerSteps = {
  careSeeker: [
    {
      title: "Welcome",
    },
    {
      title: "Who is the checkUp for",
    },
    {
      title: "Pre Screening Questions",
    },
    {
      title: "Select symptoms",
    },
    {
      title: "Symptom Details",
    },
    {
      title: "Interview Questions",
    },
    {
      title: "Results",
    },
    {
      title: "Recommendations",
    },
    {
      title: "Sucess",
    },
  ],
  careGiver: [
    {
      title: "Who is the checkUp for",
    },
    {
      title: "Select symptoms",
    },
    {
      title: "Symptom Details",
    },
    {
      title: "Pre Screening Questions",
    },
    {
      title: "Recommendations",
    },
    {
      title: "Results",
    },
  ],
  careAssist: [
    {
      title: "Who is checkup",
    },
    {
      title: "Welcome",
    },
    {
      title: "Pre Screening Questions",
    },
    {
      title: "Select symptoms",
    },
    {
      title: "Symptom Details",
    },
    {
      title: "Interview Questions",
    },
    {
      title: "Results",
    },
    {
      title: "Report",
    },
    {
      title: "Success",
    },
  ],
};

export const preScreeningQuestions = [
  { question: "I am overweight or obsese" },
  { question: "I have hypertension" },
  { question: "Do you smoke cigarettes?" },
  { question: "I have recently suffered an injury" },
  { question: "I have Cholestral" },
];
export const preeScreeningQuestionOptions = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
  {
    label: "I don't know",
    value: "I don't know",
  },
];

export const otherCommonSymptoms = [
  { label: "Difficulty bending down" },
  { label: "Fatigue" },
  { label: "Inability to smell properly" },
  { label: "Fever" },
  { label: "Vomiting" },
];

export const cateogorySymptoms = [
  {
    id: "generalSymptoms",
    label: "General Symptoms",
    symptoms: [
      { id: "seizure", label: "Absence seizure" },
      { id: "neck", label: "Anxiety" },
      { id: "armweak", label: "Arm or leg is weak" },
      { id: "musclecramp ", label: "Arm or leg muscle cramp on one side" },
      { id: "armitching", label: "Arm or leg is itching" },
      { id: "armshaking", label: "Arm or leg shaking" },
      { id: "arthritis1", label: "Arthritis in many joint that moves around" },
      { id: "arthritis2", label: "Arthritis of joint of hands & feet" },
      { id: "autism", label: "Autism" },
    ],
  },
  { id: "skinRelatedSymptoms", label: "Skin Related Symptoms" },
  { id: "pregnancyRelatedSymptoms", label: "Pregnancy Related Symptoms" },
];

export const bodyPartSymptoms = [
  {
    id: "head",
    label: "Head",
    symptoms: [
      { label: "Can't Pay Attention" },
      { label: "Fatigue" },
      { label: "Fever" },
    ],
  },
  {
    id: "nose",
    label: "Nose",
    symptoms: [{ label: "Blockage In Nose" }, { label: "Running Nose" }],
  },
  {
    id: "face",
    label: "Face",
    symptoms: [{ label: "Can't Move My Face" }, { label: "Cheek Bone Pain" }],
  },
  {
    id: "eyes",
    label: "Eyes",
    symptoms: [{ label: "Eye pain" }, { label: "Red eye" }],
  },
  {
    id: "ears",
    label: "Ears",
    symptoms: [{ label: "Big Ears" }, { label: "Blocked Ears" }],
  },
  {
    id: "oral_cavity",
    label: "Mouth",
    symptoms: [
      { label: "Area Under Tongue Is Swollen" },
      { label: "Area Of Mucus On Tongue " },
    ],
  },
  {
    id: "neck_or_throat",
    label: "Neck",
    symptoms: [{ label: "Sore thoat" }, { label: "Cough" }],
  },
  {
    id: "chest",
    label: "Chest",
    symptoms: [
      { label: "Chest pain" },
      { label: "Palpitations" },
      { label: "Heartburn" },
    ],
  },
  {
    id: "breasts",
    label: "Breasts",
    symptoms: [
      { label: "Pain or tenderness in one breast" },
      { label: "Pain or tenderness in both breast" },
    ],
  },
  {
    id: "upper_abdomen",
    label: "Upper Abdomen",
    symptoms: [
      { label: "Stomach pain " },
      { label: "Upper central abdominal pain" },
      { label: "Upper left side abdominal pain" },
      { label: "Upper right side abdominal pain" },
      { label: "Colic abdominal pain" },
      { label: "Burning or gnawling abdominal pain" },
    ],
  },
  {
    id: "mid_abdomen",
    label: "Middle Abdomen",
    symptoms: [
      { label: "Stomach pain" },
      { label: "Cramp before period" },
      { label: "Central abdominal pain" },
      { label: "Crampy stomach pain" },
      { label: "Colic abdominal pain" },
      { label: "Burning or gnawling abdominal pain" },
    ],
  },
  {
    id: "lower_abdomen",
    label: "Lower Abdomen",
    symptoms: [
      { label: "Stomach pain" },
      { label: "Cramp before period" },
      { label: "Lower left side abdominal pain" },
      { label: "Lower right abdominal pain" },
      { label: "Crampy stomach pain" },
      { label: "Colic abdominal pain" },
    ],
  },
  {
    id: "thigh",
    label: "Thigh",
    symptoms: [
      { label: "Thigh pain" },
      { label: "Hip pain" },
      { label: "Pain in lower limb" },
      { label: "Pain while moving hip" },
    ],
  },
  {
    id: "knee",
    label: "Knee",
    symptoms: [
      { label: "Pain in one knee" },
      { label: "Hip in both lower limbs" },
      { label: "Pain in lower limb" },
      { label: "Pain while moving knee" },
    ],
  },
  {
    id: "lower_leg",
    label: "Lower Leg",
    symptoms: [
      { label: "Pain in one knee" },
      { label: "Hip in both lower limbs" },
      { label: "Severe pain in lower limb" },
      { label: "Pain in calf" },
    ],
  },
  {
    id: "foot",
    label: "Foot",
    symptoms: [
      { label: "Pain in one foot" },
      { label: "Ankle pain" },
      { label: "Toe pain " },
      { label: "Sore Nail" },
    ],
  },
  {
    id: "upper_arm",
    label: "Upper arm",
    symptoms: [{ label: "Pain in upper arm" }, { label: "Pain in upper limb" }],
  },
  {
    id: "forearm",
    label: "Forearm",
    symptoms: [{ label: "Pain in forearm" }, { label: "Swollen Elbow" }],
  },
  {
    id: "elbow",
    label: "Elbow",
    symptoms: [
      { label: "Elbow pain" },
      { label: "Elbow injury" },
      { label: "Swollen Elbow" },
    ],
  },
  {
    id: "hand",
    label: "Hand",
    symptoms: [{ label: "Wrist Pain" }, { label: "Swollen hand" }],
  },
  {
    id: "back",
    label: "Back",
    symptoms: [
      { label: "Back Pain" },
      { label: "Sudden back pain" },
      { label: "Severe back pain" },
    ],
  },
  {
    id: "lower_back",
    label: "Lower Back",
    symptoms: [
      { label: "Lower back pain" },
      { label: "Sudden back pain" },
      { label: "Severe back pain" },
    ],
  },
  {
    id: "buttocks",
    label: "Buttocks",
    symptoms: [
      { label: "Buttocks pain" },
      { label: "Hip pain" },
      { label: "Ulcer" },
    ],
  },
];


export const SYMPTOM_QUESTIONS = {

  Headache: [
    {
      id: "headache_type",
      question: "Where is the headache located?",
      type: "single",
      options: ["Whole head", "Forehead / front", "One side only", "Back of head", "Behind the eyes"],
    },
    {
      id: "headache_nature",
      question: "How would you describe the headache?",
      type: "multi",
      options: ["Throbbing / pulsating", "Pressure / squeezing", "Stabbing / sharp", "Dull ache", "Burning"],
    },
    {
      id: "headache_triggers",
      question: "Do any of these trigger your headache?",
      type: "multi",
      options: ["Bright lights", "Loud noise", "Stress", "Skipping meals", "Screen time", "Alcohol", "Strong smells"],
    },
    // {
    //   id: "headache_nausea",
    //   question: "Do you experience nausea or vomiting with the headache?",
    //   type: "single",
    //   options: ["Yes, always", "Sometimes", "No"],
    // },
  ],

  Fever: [
    {
      id: "fever_temp",
      question: "What is your current temperature?",
      type: "single",
      options: ["Normal (< 37.5°C)", "Low grade (37.5–38°C)", "Moderate (38–39°C)", "High (39–40°C)", "Very high (> 40°C)", "Not measured"],
    },
    {
      id: "fever_pattern",
      question: "What is the fever pattern?",
      type: "single",
      options: ["Constant", "Comes and goes (intermittent)", "Rises in the evening", "With shaking chills", "Breaks with sweating"],
    },
    {
      id: "fever_other",
      question: "What other symptoms accompany the fever?",
      type: "multi",
      options: ["Chills / rigors", "Body ache", "Sore throat", "Rash", "Diarrhea", "Cough", "Runny nose"],
    },
  ],

  "Chest pain": [
    {
      id: "chest_nature",
      question: "How would you describe the chest pain?",
      type: "single",
      options: ["Sharp / stabbing", "Dull / aching", "Tight / squeezing", "Burning", "Pressure", "Comes in waves"],
    },
    {
      id: "chest_radiation",
      question: "Does the pain spread anywhere?",
      type: "multi",
      options: ["Left arm", "Jaw", "Back", "Shoulder", "Abdomen", "No, stays in chest"],
    },
    {
      id: "chest_triggers",
      question: "What makes the chest pain worse?",
      type: "multi",
      options: ["Physical exertion", "Deep breathing", "Lying down", "Eating", "Stress / anxiety", "Nothing specific"],
    },
    // {
    //   id: "chest_breath",
    //   question: "Is there associated shortness of breath?",
    //   type: "single",
    //   options: ["Yes, significant", "Yes, mild", "No"],
    // },
  ],

  Nausea: [
    {
      id: "nausea_vomiting",
      question: "Have you vomited?",
      type: "single",
      options: ["Yes, multiple times", "Yes, once or twice", "Felt like it but haven't", "No"],
    },
    {
      id: "nausea_trigger",
      question: "What seems to trigger or worsen nausea?",
      type: "multi",
      options: ["After eating", "Smells", "Motion", "Medications", "Stress", "Morning time", "No clear trigger"],
    },
    {
      id: "nausea_food",
      question: "Can you keep food and fluids down?",
      type: "single",
      options: ["Yes, normally", "With difficulty", "No, vomiting everything"],
    },
  ],

  "Stomach pain": [
    {
      id: "stomach_location",
      question: "Where in the abdomen is the pain?",
      type: "single",
      options: ["Upper middle", "Upper right", "Upper left", "Around navel", "Lower right", "Lower left", "Whole abdomen"],
    },
    {
      id: "stomach_nature",
      question: "What does the pain feel like?",
      type: "multi",
      options: ["Cramping", "Sharp", "Dull ache", "Burning", "Gnawing", "Bloating pressure"],
    },
    {
      id: "stomach_meals",
      question: "Is the pain related to meals?",
      type: "single",
      options: ["Gets worse after eating", "Gets better after eating", "No relationship to meals"],
    },
  ],

  "Pelvic pain": [
    {
      id: "pelvic_cycle",
      question: "Is the pelvic pain related to your menstrual cycle?",
      type: "single",
      options: ["Yes, during period", "Yes, mid-cycle", "Yes, before period", "No relationship"],
    },
    {
      id: "pelvic_nature",
      question: "How would you describe the pain?",
      type: "multi",
      options: ["Cramping", "Sharp stabbing", "Dull ache", "Pressure", "Burning"],
    },
    {
      id: "pelvic_other",
      question: "Are there associated symptoms?",
      type: "multi",
      options: ["Bloating", "Abnormal discharge", "Pain during intercourse", "Frequent urination", "Back pain"],
    },
  ],

  Cough: [
    {
      id: "cough_type",
      question: "What type of cough do you have?",
      type: "single",
      options: ["Dry / non-productive", "Wet / with phlegm", "Whooping / barking", "Blood-tinged"],
    },
    {
      id: "cough_phlegm",
      question: "If there is phlegm, what does it look like?",
      type: "single",
      options: ["Clear / white", "Yellow", "Green", "Brown", "Blood-streaked", "No phlegm"],
    },
    {
      id: "cough_when",
      question: "When is the cough worse?",
      type: "multi",
      options: ["Morning", "Night", "After eating", "Exercise", "Cold air", "Lying down", "All the time"],
    },
  ],

  Anxiety: [
    {
      id: "anxiety_symptoms",
      question: "Which physical symptoms accompany your anxiety?",
      type: "multi",
      options: ["Racing heart", "Shortness of breath", "Sweating", "Trembling", "Dizziness", "Chest tightness", "Nausea"],
    },
    {
      id: "anxiety_frequency",
      question: "How often do you experience anxiety episodes?",
      type: "single",
      options: ["Constantly", "Multiple times a day", "Once a day", "A few times a week", "Occasionally"],
    },
    {
      id: "anxiety_trigger",
      question: "Do you know what triggers your anxiety?",
      type: "single",
      options: ["Yes, specific situations", "Yes, general stress", "No identifiable trigger", "Not sure"],
    },
  ],

  Dizziness: [
    {
      id: "dizzy_type",
      question: "How would you describe the dizziness?",
      type: "single",
      options: ["Room spinning (vertigo)", "Lightheadedness / faintness", "Unsteadiness / imbalance", "Floating sensation"],
    },
    {
      id: "dizzy_triggers",
      question: "What triggers or worsens the dizziness?",
      type: "multi",
      options: ["Standing up quickly", "Head movements", "Looking up / down", "Walking", "Lying down", "No specific trigger"],
    },
    {
      id: "dizzy_assoc",
      question: "Are there associated symptoms?",
      type: "multi",
      options: ["Nausea", "Ringing in ears", "Hearing loss", "Headache", "Vision changes", "Fainting"],
    },
  ],
  Fatigue: [
  {
    id: "fatigue_level",
    question: "How severe is your fatigue?",
    type: "scale",
    options: [
      { label: "Mild", value: "mild" },
      { label: "Moderate", value: "moderate" },
      { label: "Severe", value: "severe" }
    ]
  },
  {
    id: "fatigue_duration",
    question: "How long have you been feeling fatigued?",
    type: "single",
    options: ["Few days", "1–2 weeks", "More than 2 weeks"]
  },
  {
    id: "fatigue_assoc",
    question: "Do you have any associated symptoms?",
    type: "multi",
    options: ["Sleep issues", "Stress", "Weight loss", "Fever", "None"]
  }
],
"Back Pain": [
  {
    id: "back_location",
    question: "Where is the pain located?",
    type: "single",
    options: ["Upper back", "Lower back", "Whole back"]
  },
  {
    id: "back_trigger",
    question: "What makes it worse?",
    type: "multi",
    options: ["Movement", "Sitting", "Lifting", "Sleeping", "Nothing"]
  },
  {
    id: "back_radiation",
    question: "Does pain radiate?",
    type: "multi",
    options: ["Legs", "Arms", "No radiation"]
  }
],
Insomnia: [
  {
    id: "sleep_issue",
    question: "What type of sleep problem do you have?",
    type: "multi",
    options: ["Difficulty falling asleep", "Frequent waking", "Early waking"]
  },
  {
    id: "sleep_duration",
    question: "How many hours do you sleep?",
    type: "single",
    options: ["<4 hours", "4–6 hours", "6–8 hours", "Normal"]
  },
  {
    id: "sleep_cause",
    question: "Possible causes?",
    type: "multi",
    options: ["Stress", "Screen time", "Caffeine", "Unknown"]
  }
],
"Shortness of Breath": [
  {
    id: "breath_when",
    question: "When does it occur?",
    type: "multi",
    options: ["At rest", "During activity", "Lying down", "Suddenly"]
  },
  {
    id: "breath_severity",
    question: "How severe is it?",
    type: "scale",
    options: [
      { label: "Mild", value: "mild" },
      { label: "Moderate", value: "moderate" },
      { label: "Severe", value: "severe" }
    ]
  },
  {
    id: "breath_assoc",
    question: "Associated symptoms?",
    type: "multi",
    options: ["Chest pain", "Cough", "Wheezing", "Fever"]
  }
],
"Sore Throat": [
  {
    id: "throat_severity",
    question: "How severe is the pain?",
    type: "scale",
    options: [
      { label: "Mild", value: "mild" },
      { label: "Moderate", value: "moderate" },
      { label: "Severe", value: "severe" }
    ]
  },
  {
    id: "throat_swallow",
    question: "Pain while swallowing?",
    type: "single",
    options: ["Yes", "No"]
  },
  {
    id: "throat_assoc",
    question: "Associated symptoms?",
    type: "multi",
    options: ["Fever", "Cough", "Runny nose", "Voice change"]
  }
],
Bloating: [
  {
    id: "bloating_when",
    question: "When does bloating occur?",
    type: "multi",
    options: ["After eating", "All day", "Evening"]
  },
  {
    id: "bloating_pain",
    question: "Is there pain?",
    type: "single",
    options: ["Yes", "No"]
  }
],
Depression: [
  {
    id: "mood_duration",
    question: "How long have you felt this way?",
    type: "single",
    options: ["Days", "Weeks", "Months"]
  },
  {
    id: "mood_symptoms",
    question: "Symptoms?",
    type: "multi",
    options: ["Low mood", "Loss of interest", "Sleep issues", "Fatigue"]
  }
],
Rash: [
  {
    id: "rash_location",
    question: "Where is the rash?",
    type: "multi",
    options: ["Face", "Arms", "Legs", "Body"]
  },
  {
    id: "rash_type",
    question: "Type of rash?",
    type: "multi",
    options: ["Red", "Blisters", "Dry", "Itchy"]
  }
],
Constipation: [
  {
    id: "constipation_freq",
    question: "How often do you pass stool?",
    type: "single",
    options: ["Daily", "Every 2–3 days", "Less than 2/week"]
  },
  {
    id: "constipation_strain",
    question: "Do you strain?",
    type: "single",
    options: ["Yes", "No"]
  }
],
Diarrhea: [
  {
    id: "diarrhea_freq",
    question: "How frequent are stools?",
    type: "single",
    options: ["2–3/day", "4–6/day", "More than 6/day"]
  },
  {
    id: "diarrhea_type",
    question: "Type of stool?",
    type: "multi",
    options: ["Watery", "Bloody", "Mucus"]
  }
]
};

export const HISTORY_CONFIG = {
  overweightOrObese: "I am overweight or obese",
  hypertension: "I have hypertension",
  cholesterol: "I have cholesterol",
  smoking: "Do you smoke cigarettes?",
  recentInjury: "I have recently suffered an injury"
};